import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { TiresDisposalsHistory } from 'models/tires-disposals-history';
import { http } from 'services/http';

export const getTiresDisposalsHistoryApi = (params?: string) =>
  http.get<ResponseWithPagination<TiresDisposalsHistory>>(
    `${ApiPath.TIRES_DISPOSALS_HISTORY}${params}`
  );
